
ko.bindingHandlers.textDate = {
    /**
     *  
     * @param {HTMLBaseElement} element
     * @param {any} valueAccessor
     * @param {any} allBindings
     * @param {any} viewModel
     * @param {any} bindingContext
     */
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        const val = ko.unwrap(valueAccessor());
        if (!val) return;
        if (!val.endsWith('Z')) val + 'Z';
        const d = moment(val);
        element.textContent = d.toDate().toLocaleString();
    }
};

ko.bindingHandlers.textDateOnly = {
    /**
     *  
     * @param {HTMLBaseElement} element
     * @param {any} valueAccessor
     * @param {any} allBindings
     * @param {any} viewModel
     * @param {any} bindingContext
     */
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        const val = ko.unwrap(valueAccessor());
        if (!val) return;
        if (!val.endsWith('Z')) val + 'Z';
        const d = moment(val);
        element.textContent = d.toDate().toLocaleDateString();
    }
};